import { includes } from 'lodash';

export const LEVEL_ACCESS_VALUES = ['org', 'building', 'unit'] as const;

export type LevelAccess = (typeof LEVEL_ACCESS_VALUES)[number];

export const isValidLevelAccess = (value: string): value is LevelAccess =>
  includes(LEVEL_ACCESS_VALUES, value);
